import React from "react";
import Pagination from "react-bootstrap/Pagination";

const Pager = ({ className, page, pages, updatePage }) => {
  const prevPage = () => {
    const prev = page - 1;
    if (prev > 0) {
      goToPage(prev);
      window.scrollTo(0, 0);
    }
  };
  const nextPage = () => {
    const next = page + 1;
    goToPage(next);
    window.scrollTo(0, 0);
  };
  const goToPage = (page) => {
    updatePage(page);
    window.scrollTo(0, 0);
  };

  return (
    <div className={className} style={{ padding: "20px 0" }}>
      <Pagination style={{ justifyContent: "center", fontSize: "20px" }}>
        <Pagination.First onClick={() => goToPage(1)} disabled={page === 1} />
        <Pagination.Prev onClick={() => prevPage()} disabled={page === 1} />

        <Pagination.Next onClick={() => nextPage()} disabled={page === pages} />
        <Pagination.Last onClick={() => goToPage(pages)} disabled={page === pages} />
      </Pagination>
    </div>
  );
};

export default Pager;
